import type { ReactNode } from "react";

export interface EmptyStateProps {
  title?: string;
  description?: string;
  /** A glyph (shape carries meaning, not color alone). */
  glyph?: ReactNode;
  /** Primary action (e.g. a "Create" Button). */
  action?: ReactNode;
}

/** EmptyState — one of the 5 mandatory per-screen states (vide). */
export function EmptyState({
  title = "Aucun élément",
  description,
  glyph = "▢",
  action,
}: EmptyStateProps) {
  return (
    <div className="nv-state nv-state--empty" role="status">
      <div className="nv-state__glyph" aria-hidden style={{ color: "var(--nv-steel)" }}>
        {glyph}
      </div>
      <div className="nv-state__title">{title}</div>
      {description && <p className="nv-state__desc">{description}</p>}
      {action}
    </div>
  );
}
